import type { ReactNode } from 'react'
import React from 'react'
import { useTranslation } from 'next-i18next'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

interface CourseQuizLayoutProps {
  className?: string
  questionCounter: ReactNode
  questions: ReactNode
  buttons: ReactNode
}

export const CourseQuizLayout = ({
  className,
  questionCounter,
  questions,
  buttons,
}: React.PropsWithChildren<CourseQuizLayoutProps>): ReactNode => {
  const { t } = useTranslation()
  return (
    <div
      className={`flex w-full flex-col self-start ${className || ''} ${addPublicCustomClassNamePrefix('course-quiz__container')}`}
    >
      <div className="flex justify-between rounded-md bg-THEME-block-background p-6">
        <h2 className={`text-xl font-bold ${addPublicCustomClassNamePrefix('course-quiz__label')}`}>
          {t('course.quiz.label')}
        </h2>
        <span
          className={`text-xl font-bold text-THEME-primary ${addPublicCustomClassNamePrefix('course-quiz__question-counter')}`}
        >
          {questionCounter}
        </span>
      </div>
      <ul className={`${addPublicCustomClassNamePrefix('course-quiz__questions-container')}`}>
        {questions}
      </ul>
      <div
        className={`mt-auto flex justify-center gap-3 pt-8 ${addPublicCustomClassNamePrefix('course-quiz__buttons-container')}`}
      >
        {buttons}
      </div>
    </div>
  )
}
